var map = {
	"./2008.jpg": 1778,
	"./2009.jpg": 6656,
	"./2010.jpg": 5425,
	"./2011.jpg": 2928,
	"./2012.jpg": 9878,
	"./2013.jpg": 6312,
	"./2014.jpg": 6863,
	"./2015.jpg": 6721,
	"./2016.jpg": 2109,
	"./2017.jpg": 9504,
	"./2018.jpg": 6231,
	"./2019.jpg": 2057,
	"./2020.jpg": 9703,
	"./2021.jpg": 2134,
	"./2022.jpg": 5185,
	"./2023.jpg": 5615,
	"./2024.jpg": 5897,
	"./2025.jpg": 4900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 494;